// extracted by mini-css-extract-plugin
module.exports = {"remindBtn":"lightningReminder_remindBtn__46rGh","reminded":"lightningReminder_reminded__BKgt_"};